import { useTranslation } from 'react-i18next'

import { formatPrice, productTitle } from '@/lib/format'

import { CartItemFlash, CartItemIcon, CartItemImage, CartItemInfo, CartItemPrice, CartItemQty, CartItemRemove, CartItemWrapper, QtyButton } from './CartItem.styles'

const Glyph = ({ d }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
    <path d={d} />
  </svg>
)

const CartItem = ({ item, currency, highlightKey, onIncrement, onDecrement, onRemove }) => {
  const { t, i18n } = useTranslation()
  const title = productTitle(item, i18n.language)

  return (
    <CartItemWrapper data-cart-id={item.id}>
      {highlightKey && <CartItemFlash key={highlightKey} />}
      {item.icon ? (
        <CartItemIcon>{item.icon}</CartItemIcon>
      ) : (
        <CartItemImage>
          <img src={item.imageUrl} alt={title} />
        </CartItemImage>
      )}
      <CartItemInfo>
        <span className="title" title={title}>{title}</span>
        <span className="unit-price">
          {formatPrice(item.price, currency)}
        </span>
      </CartItemInfo>
      <CartItemQty>
        <QtyButton onClick={onDecrement} aria-label={t('cartPanel.decrease')}>
          <Glyph d="M6 12h12" />
        </QtyButton>
        <span className="qty">{item.qty}</span>
        <QtyButton onClick={onIncrement} aria-label={t('cartPanel.increase')}>
          <Glyph d="M6 12h12M12 6v12" />
        </QtyButton>
      </CartItemQty>
      <CartItemPrice>
        {formatPrice(item.qty * item.price, currency)}
      </CartItemPrice>
      <CartItemRemove onClick={onRemove} aria-label={t('cartPanel.remove')}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <path d="M7 7l10 10M17 7L7 17" />
        </svg>
      </CartItemRemove>
    </CartItemWrapper>
  )
}

export default CartItem
